import { ReviewStatus } from "../review-queue/constants/review-queue.model";

export type SupportActionType = 'inquireDataDoc' | 'requestRequote';

export type ReviewAssignmentAction = 'assign' | 'reassign';

export type ReviewAssignmentStatus =
  | 'Unassigned'
  | 'Assigned'
  | 'Review In-Progress'
  | 'Agent Follow-up'
  | 'Requote Requested'
  | 'Review Completed'
  | 'Payment Follow-up'
  | 'Awaiting Policy'
  | 'Policy Issues';


export interface ApplicationReviewLeadContext {
  lastActivity: string;
  network: string;
  applicants: number;
  priority: unknown;
  id?: string | number;
  leadId?: string;
  firstName?: string;
  lastName?: string;
  status?: ReviewAssignmentStatus;
  reviewerAssigned?: string;
}

export interface ReviewerAssignmentLead {
  reviewQueueId: string;
  leadInfoId: string;
  mafFinalSubmissionId?: string | null;
  assignedAgentId?: string | null;
}

export interface ReviewerAssignmentPayload {
  reviewerId: string;
  reviewStatus: ReviewStatus;
  isReassigned: boolean;
  leads: ReviewerAssignmentLead[];
  reassignedReason?: string | null;
}

export interface SupportAction {
  action: SupportActionType;
  iconName: string;
  title: string;
  description: string;
}

export interface ApplicantInfoApiRes {
  readonly firstName: string;
  readonly lastName: string;
  readonly dob: string;
  readonly gender: string;
  readonly emirateOfVisaInsurance: string;
  readonly maritalStatus: string;
  readonly emirateOfVisaInsuranceId?: string;
  readonly id?: string;
  readonly passportFileName?: string;
  readonly passportFilePath?: string;
  readonly passportFileSize?: number;
  readonly passportFileType?: string;
  readonly passportInfoId?: string;
}

export type BasicInfoFieldKey =
  | 'firstName'
  | 'lastName'
  | 'dob'
  | 'gender'
  | 'emirateOfVisaInsurance'
  | 'maritalStatus'
  | 'emirateOfVisaInsuranceId'
  | 'id';

export interface FieldMeta {
  label: string;
  icon: string;
}

export enum SubmissionStatus {
  PdfGenerated = 'PdfGenerated',
  ApplicationSubmitted = 'ApplicationSubmitted'
}

export enum ReviewActionType {
  MARK_APPLICANT = 'MarkApplicant',
  UNMARK_APPLICANT = 'UnmarkApplicant',
  MARK_DOCUMENT = 'MarkDocument',
  UNMARK_DOCUMENT = 'UnmarkDocument',
}

export interface MarkOrUnmarkPayload {
  reviewQueueId: string;
  mafFormSubmissionId: string;
  actionType: ReviewActionType | string | number;
  applicantInfoId?: string;
  MafFormSubmissionId?: string | null;
}

export interface SubmitApplicationReadyPayload {
  leadInfoId: string;
  reviewQueueId: string;
  version: string;
  leadInfo?: any;
  completionStatus?: any;
  totalPremiumWithTaxes?: number;
  product?: any;
  agent?: any;
  applicants?: Array<{
    applicantId: string;
    applicantName: string;
  }>;
}

export interface ReviewSummaryApplicantItem {
  mafFormSubmissionId: string;
  applicantId: string;
}

export interface ReviewSummaryPayload {
  mafFinalSubmissionId: string;
  leadInfoId: string;
  applicants: ReviewSummaryApplicantItem[];
}
